import React from 'react';
import { Link, useLocation } from 'react-router-dom';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path ? 'text-aspect-black font-medium' : 'text-aspect-gray hover:text-aspect-black';
  };
  return <div className="min-h-screen flex flex-col max-w-5xl mx-auto px-6 md:px-12 border-x border-aspect-gray/10 bg-aspect-white" data-id="element-44">
      <header className="py-8 md:py-12 flex flex-col md:flex-row md:items-center justify-between gap-6 border-b border-aspect-gray/20" data-id="element-45">
        <Link to="/" className="block" data-id="element-46">
          <img src="https://cdn.magicpatterns.com/uploads/8kwaDUGYpbA2PfE8inV6SY/Aspect_Wordmark_Black.svg" alt="Aspect" className="h-12 md:h-14" data-id="element-47" />
        </Link>

        <nav className="flex items-center gap-6 md:gap-8 text-sm" data-id="element-48">
          <Link to="/" className={isActive('/')} data-id="element-49">
            Overview
          </Link>
          <Link to="/how-it-works" className={isActive('/how-it-works')} data-id="element-50">
            How It Works
          </Link>
          <Link to="/trust" className={isActive('/trust')} data-id="element-51">
            Trust
          </Link>
          <Link to="/manufacturers" className={isActive('/manufacturers')} data-id="element-52">
            For Manufacturers
          </Link>
          <Link to="/faq" className={isActive('/faq')} data-id="element-53">
            FAQs
          </Link>
          <Link to="/about" className={isActive('/about')} data-id="element-54">
            About
          </Link>
        </nav>
      </header>

      <main className="flex-1 py-12 md:py-20" data-id="element-55">{children}</main>

      <footer className="py-12 border-t border-aspect-gray/20" data-id="element-56">
        <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-57">
          {/* Column 1 - System */}
          <div data-id="element-58">
            <h3 className="text-sm font-medium text-aspect-black mb-4" data-id="element-59">
              System
            </h3>
            <nav className="flex flex-col gap-3 text-sm text-aspect-gray" data-id="element-60">
              <Link to="/" className="hover:text-aspect-black" data-id="element-61">
                Overview
              </Link>
              <Link to="/how-it-works" className="hover:text-aspect-black" data-id="element-62">
                How It Works
              </Link>
              <Link to="/trust" className="hover:text-aspect-black" data-id="element-63">
                Trust & Verification
              </Link>
              <Link to="/faq" className="hover:text-aspect-black" data-id="element-64">
                FAQs
              </Link>
              <Link to="/about" className="hover:text-aspect-black" data-id="element-65">
                About
              </Link>
              <Link to="/terms" className="hover:text-aspect-black" data-id="element-66">
                Terms of Use
              </Link>
              <Link to="/privacy" className="hover:text-aspect-black" data-id="element-67">
                Privacy Policy
              </Link>
            </nav>
          </div>

          {/* Column 2 - Participation */}
          <div data-id="element-68">
            <h3 className="text-sm font-medium text-aspect-black mb-4" data-id="element-69">
              Participation
            </h3>
            <nav className="flex flex-col gap-3 text-sm text-aspect-gray" data-id="element-70">
              <Link to="/manufacturers" className="hover:text-aspect-black" data-id="element-71">
                For Manufacturers
              </Link>
              <Link to="/architects" className="hover:text-aspect-black" data-id="element-72">
                For Architects
              </Link>
              <Link to="/owners" className="hover:text-aspect-black" data-id="element-73">
                For Owners
              </Link>
              <Link to="/photographers" className="hover:text-aspect-black" data-id="element-74">
                For Photographers
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom info */}
        <div className="pt-8 border-t border-aspect-gray/10 text-sm text-aspect-gray space-y-2" data-id="element-75">
          <div data-id="element-76">© 2025 Aspect</div>
          <div data-id="element-77">Rights. Verification. Metadata.</div>
        </div>
      </footer>
    </div>;
}